var React = require('react');

function AsanaForwardBendC (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M17.578,21.744c0,0,0.911,2.531,1.658,4.608\n\tc0.749,2.079,3.039,3.158,5.118,2.41c2.078-0.748,3.157-3.04,2.408-5.117c-0.429-1.196-1.596-4.44-2.511-6.981\n\tC22.17,10.889,17.147,5,12,5c-4.75,0-7,2.917-7,6.25c0,5,4.917,7.417,8,23.75h7 M17,35c-1-9.478-2.797-17.264-4.258-23.083\n\tC15.537,18.014,19,19,21.75,19c2.048,0,3.85-1.102,4.964-2.162c3.988-3.795,8.866-8.436,8.866-8.436"}));
}

AsanaForwardBendC.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaForwardBendC;

AsanaForwardBendC.default = AsanaForwardBendC;
